

export class DocumentTypeDto implements IDocumentTypeDto {
    id!: number;
    documentType!: string | undefined;
    documentDirectory!: string | undefined;
    isActive!: boolean;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentType = _data["documentType"];
            this.documentDirectory = _data["documentDirectory"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentType"] = this.documentType;
        data["documentDirectory"] = this.documentDirectory;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IDocumentTypeDto {
    id: number;
    documentType: string | undefined;
    documentDirectory: string | undefined;
    isActive: boolean;
}

